import React, { useState } from "react";
import "./css/NumberField.css";
import {
  NumberField,
  Label,
  Group,
  Input,
  Button,
} from "react-aria-components";

import { IoMdArrowDropup } from "react-icons/io";
import { IoMdArrowDropdown } from "react-icons/io";

function NumberInput(props) {
  const { value, label, onChange, style, id, submitRef } = props;

  const onChangeHandler = (value) => {
    onChange(value);
  };

  return (
    <NumberField
      {...props}
      onChange={(value) => onChangeHandler(value)}
      className={"number-field"}
    >
      <Label>{label}</Label>
      <Group className={"field-group"} style={{ ...style }}>
        <Input
          id={id}
          className={"number-input"}
          style={{
            backgroundColor: props.bgColor,
            borderColor: props.borderColor,
          }}
          value={value}
          onChange={(e) => {
            onChangeHandler(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") submitRef.current.focus();
          }}
        />
        <span
          style={{
            backgroundColor: props.bgColor,
            borderColor: props.borderColor,
          }}
        >
          <Button className={"count-btn"} slot="increment">
            <IoMdArrowDropup className="icon" />
          </Button>
          <Button className={"count-btn"} slot="decrement">
            <IoMdArrowDropdown className="icon" />
          </Button>
        </span>
      </Group>
    </NumberField>
  );
}

export default NumberInput;
